import { BusyButton } from '../BusyButton'
import React from 'react'
import { jsonStringify } from '@ztechapps/common.utils'

export type LoadMoreButtonProps = {
  dataArray?: any[]
  pageInfo?: any
  loadMoreEntries?: any
  searchString?: string
  sortObject?: Record<any, any>
  loading?: boolean
  sort?: Record<any, any>
  filter?: Record<any, any>
  className?: any
  bsStyle?: any
  bsSize?: any
}

export const LoadMoreButton = ({
  dataArray,
  pageInfo,
  loadMoreEntries,
  searchString,
  sortObject,
  loading,
  sort,
  filter,
  className,
  bsStyle,
  bsSize,
}: LoadMoreButtonProps) => {
  //if there is value for filter then user it
  if (filter) searchString = jsonStringify(filter)

  if (sort) sortObject = sort

  let renderLoadMore = null
  if (loadMoreEntries) {
    const hasMore = (pageInfo && pageInfo.count) !== (dataArray && dataArray.length)
    const handleLoadMore = () => {
      const { length } = dataArray || {}
      return loadMoreEntries(length, searchString, sortObject)
    }

    let loadMoreButton = null
    if (hasMore) {
      loadMoreButton = (
        <BusyButton
          disabled={!hasMore}
          isBusy={loading}
          onClick={handleLoadMore}
          className={className}
          bsStyle={bsStyle}
          bsSize={bsSize}
        >
          Load More...
        </BusyButton>
      )
    }

    renderLoadMore = <div className="">{loadMoreButton}</div>
  }

  return renderLoadMore
}
